import config from "../config";
import { POPULAR_ARTICLES_SECTION_ID, ZENDESK_URL } from "./constants";

const getNewRequest = ({
  method = "GET",
  token,
  baseUrl,
  path,
  body,
  setAuth = true,
  payload,
}) => {
  const options = {
    method,
    headers: {
      Accept: "application/json",
    },
  };

  if (!token) {
    token = payload.PGSupportToken;
  }
  if (!baseUrl) {
    baseUrl = payload.PGSupportUrl;
  }
  if (setAuth) {
    options.headers = Object.assign({}, options.headers, {
      Authorization: token,
    });
  }
  if (body) {
    options.body = JSON.stringify(body);
  }
  const url = path ? baseUrl + path : baseUrl;
  const request = { url, options };
  return request;
};

export const validateToken = async ({ token, baseUrl }) => {
  const request = getNewRequest({
    method: "POST",
    token,
    baseUrl,
    path: "support/token",
  });
  try {
    const response = await fetch(request.url, request.options);
    // console.log('response - ', response);
    if (response && response.status === 200) {
      return response.json();
    } else {
      console.error("Error verifying jwt token");
      return Promise.reject(new Error("Server error"));
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

const openUrl = ({ url }) => {
  window.open(url, "_blank");
  window.focus();
};

export const getRedirect = async ({ queryStr, payload }) => {
  try {
    // if payload not present then open url
    if (!payload) {
      openUrl({
        url: queryStr,
      });
      return;
    }

    // Get jwt url
    const request = getNewRequest({
      method: "POST",
      token: payload.PGSupportToken,
      baseUrl: payload.PGSupportUrl,
      path: "support/redirect",
      body: {
        json: true,
        redirectUrl: queryStr, 
      }
    });
    try {
      const response = await fetch(request.url, request.options);
      console.log('response - ', response);
      if (response && response.status === 200) {
        const jsonResponse = await response.json();
        // console.log('url - ', jsonResponse);
        const form = document.createElement("form");
        form.method = "POST";
        form.target = "_blank";
        form.action = jsonResponse.link;
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      } else {
        console.error("Error submitting response");
      }
    } catch (error) {
      console.error("Error accessing jwt token");
    }
  } catch (err) {
    console.error("Error getting zendesk link - ", err);
  }
};

export const submitTicket = async ({ payload = {}, body = {} }) => {
  body.currentUrl = payload.currentUrl;
  body.domainUrl = payload.domainUrl;
  body.logRocket = payload.logRocket;

  const request = getNewRequest({
    method: "POST",
    path: "support/tickets",
    body,
    payload,
  });
  try {
    // const response = await sendPayloadToZapier({ body, payload });
    const response = await fetch(request.url, request.options);
    if (response && response.status === 200) {
      return Promise.resolve(response.json());
    } else {
      return Promise.reject(new Error("Server error"));
    }
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getArticles = async ({ payload }) => {
  try {
    const request = getNewRequest({
      method: "GET",
      path: `support/articles`,
      payload,
    });
    const response = await fetch(request.url, request.options);
    // console.log('response - ', response);
    if (response && response.status === 200) {
      return response.json();
    } else {
      console.error("Error getting data");
      return Promise.reject(new Error("Server error"));
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

export const searchArticles = async ({ searchQuery, payload }) => {
  try {
    const request = getNewRequest({
      method: "GET",
      path: `support/search?query=${searchQuery}`,
      payload,
    });
    const response = await fetch(request.url, request.options);
    // console.log('response - ', response);
    if (response && response.status === 200) {
      return response.json();
    } else {
      console.error("Error getting data");
      return Promise.reject(new Error("Server error"));
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

export const uploadFileAPI = async ({ body, payload }) => {
  try {
    const request = getNewRequest({
      method: "POST",
      path: "admin/file-upload",
      body: body,
      payload: payload,
    });
    const appToken = payload && payload.appToken;
    if (appToken) {
      request.options.headers = Object.assign({}, request.options.headers, {
        Authorization: `bearer ${appToken}`,
      });
    }
    const response = await fetch(request.url, request.options);
    // console.log("response - ", response);
    if (response && response.status === 200) {
      return response.json();
    } else {
      console.error("Error getting data");
      return Promise.reject(new Error("Server error"));
    }
  } catch (error) {
    return Promise.reject(error);
  }
};



// WEBPACK FOOTER //
// ./api/index.js